import type { IconProps } from '../types/IconProps.ts';
export const ClipboardX: IconProps = {
    name: 'ClipboardX',
    children: [
        `<path d="M8 4H6a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />`,
        `<path d="M14 2h-4a2 2 0 1 0 0 4h4a2 2 0 1 0 0-4M9 11l6 6M9 17l6-6" />`,
    ]
};